export function getFullSiteUrl(path) {
  if (!path.startsWith('/') || !process.env.REACT_APP_SITE_URL) {
    return path;
  }
  return `${process.env.REACT_APP_SITE_URL}${path}`;
}
